import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableValue } from '../interfaces.js';
import { KnowEdmTableData } from './table-enums.js';

const wellheadPositionMap = new Map<KnowEdmTableData, KnowEdmTableValue<KnowEdmTableData>>();

wellheadPositionMap.set(KnowEdmTableData.EPSGCode, {
  key: KnowEdmTableData.EPSGCode,
  label: 'EPSG Code',
  unit: '',
  quantity: '',
  tooltip: 'entities_epsgCodeTooltip',
});

wellheadPositionMap.set(KnowEdmTableData.GeographicalLongitude, {
  key: KnowEdmTableData.GeographicalLongitude,
  label: 'Geographical Longitude',
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  tooltip: 'entities_geographicalLongitudeTooltip',
});

wellheadPositionMap.set(KnowEdmTableData.GeographicalLatitude, {
  key: KnowEdmTableData.GeographicalLatitude,
  label: 'Geographical Latitude',
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  tooltip: 'entities_geographicalLatitudeTooltip',
});

wellheadPositionMap.set(KnowEdmTableData.Easting, {
  key: KnowEdmTableData.Easting,
  label: 'Easting',
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Location,
  tooltip: 'entities_mapPosititionNSTooltip',
});

wellheadPositionMap.set(KnowEdmTableData.Northing, {
  key: KnowEdmTableData.Northing,
  label: 'Northing',
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Location,
  tooltip: 'entities_mapPosititionNSTooltip',
});

wellheadPositionMap.set(KnowEdmTableData.LocalOffsetEast, {
  key: KnowEdmTableData.LocalOffsetEast,
  label: 'Local Offset East',
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Location,
  tooltip: 'entities_mapPosititionNSTooltip',
});

wellheadPositionMap.set(KnowEdmTableData.LocalOffsetNorth, {
  key: KnowEdmTableData.LocalOffsetNorth,
  label: 'Local Offset North',
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Location,
  tooltip: 'entities_mapPosititionNSTooltip',
});

export {
  wellheadPositionMap,
};
